/** Home, the waiting list and creating a workspace (K1). */
export const firstRunCopy = {
  retry: 'Retry',
  workspaceFallback: 'Workspace',
  home: {
    noWorkspace: 'No workspace yet',
    noWorkspaceDescription:
      'A workspace holds its own topics, agents and people.',
    newWorkspace: 'New workspace',
    noTopic: 'No topic selected',
    noTopicDescription: 'Pick a topic or create one.',
    newTopic: 'New topic',
  },
  waiting: {
    title: 'Waiting on you',
    description: 'Pending reviews and decisions',
    loadFailed: 'Could not load the waiting list.',
    empty: 'No agents are waiting on you.',
    action: { plan: 'Approve plan', question: 'Answer question' },
    agentFallback: 'agent',
    blocks: (agent: string) => `Blocks ${agent}`,
    blocksThread: (agent: string, thread: string) =>
      `Blocks ${agent} · opens thread ${thread}`,
  },
  newWorkspace: {
    title: 'New workspace',
    description: 'A workspace holds its own topics, agents and people.',
    name: 'Name',
    submit: 'Create workspace',
    cancel: 'Cancel',
    createFailed: 'Failed to create workspace — try a different name.',
  },
} as const
